import { render, staticRenderFns } from "./Swot.vue?vue&type=template&id=f2373748&scoped=true"
import script from "./Swot.vue?vue&type=script&lang=ts"
export * from "./Swot.vue?vue&type=script&lang=ts"
import style0 from "./Swot.vue?vue&type=style&index=0&id=f2373748&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2373748",
  null
  
)

export default component.exports